// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { TooltipProvider } from './components/chartsdb/tooltip/tooltip';
import { HeroUIProvider } from '@heroui/react';
import { HeadData } from '@/head/head-data';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Title } from '@/components/title.tsx';
import NotificationToaster from '@/components/notifications/notification-toaster.tsx';

const queryClient = new QueryClient();

export const App = () => {

  return (
    <>
      <HeadData />
      <HeroUIProvider>
        <TooltipProvider>
          <NotificationToaster />
          <Title />
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </TooltipProvider>
      </HeroUIProvider>
    </>
  );
};
